import React from 'react';

import Avatar, { AvatarProps } from '@/components/atoms/avatar';
import { BlockReference } from '@/components/cms/types/block';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { ImageStrapi } from '@/components/cms/types/image';

import { transformCMSAssetToNextImageProps } from '../image/ImageSB';

export interface AvatarStrapiProps {
  image: BlockReference<ImageStrapi>;
  size: AvatarProps['size'];
}

export default function AvatarStrapi({
  block,
}: BlockComponentModel<AvatarStrapiProps>) {
  const { size } = block;

  const props = transformCMSAssetToNextImageProps({
    ...block,
  });

  if (!props.src) {
    return null;
  }

  return <Avatar size={size} {...props} />;
}
